import { createContext } from 'react';
import { SourcePages, Features } from 'lib/EventSchema';

export const FilterEventContext = createContext({
  feature: '' as Features,
  sourcePage: '' as SourcePages,
});
